import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { leadService } from '../../services/api';
import { Input, Select, Button, Toast } from '../../components/ui';

const EditLeadForm = ({ lead, courses, leadSources, onClose, onUpdated }) => {
  const { dark } = useTheme();
  const [form, setForm] = useState({
    fullName: lead.fullName || '',
    email: lead.email || '',
    mobile: lead.mobile || '',
    qualification: lead.qualification || '',
    city: lead.city || '',
    state: lead.state || '',
    priority: lead.priority || 'medium',
    course: lead.course?._id || lead.course || '',
    leadSource: lead.leadSource?._id || lead.leadSource || '',
    remarks: lead.remarks || '',
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fullName || !form.mobile) {
      setToast({ msg: 'Full Name and Mobile are required', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      await leadService.update(lead._id, form);
      setToast({ msg: 'Lead updated successfully!', type: 'success' });
      if (onUpdated) onUpdated();
      setTimeout(onClose, 1500);
    } catch (err) {
      setToast({ msg: err.response?.data?.message || err.message || 'Error updating lead', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const f = (field) => ({ value: form[field], onChange: e => setForm({ ...form, [field]: e.target.value }) });

  return (
    <div>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
          <Input label="Full Name *" {...f('fullName')} placeholder="Enter full name" />
          <Input label="Mobile Number *" {...f('mobile')} placeholder="Enter mobile" />
          <Input label="Email" {...f('email')} placeholder="Enter email" type="email" />
          <Select label="Course" {...f('course')} options={courses.map(c => ({ value: c._id, label: c.name }))} />
          <Select label="Lead Source" {...f('leadSource')} options={leadSources.map(s => ({ value: s._id, label: s.name }))} />
          <Select label="Priority" {...f('priority')} options={['low', 'medium', 'high', 'urgent']} />
          <Input label="Qualification" {...f('qualification')} placeholder="e.g. B.Tech" />
          <Input label="City" {...f('city')} placeholder="Enter city" />
          <Input label="State" {...f('state')} placeholder="Enter state" />
        </div>
        <div style={{ fontSize: 11, color: dark ? '#64748B' : '#94A3B8', marginBottom: 14 }}>
          Currently assigned to <strong>{lead.assignedCounsellor ? `${lead.assignedCounsellor.firstName} ${lead.assignedCounsellor.lastName || ''}` : 'no one'}</strong>. Use the Assign action on the leads list to reassign.
        </div>
        <Input label="Remarks" {...f('remarks')} placeholder="Additional information..." />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
          <Button variant="outline" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={loading}>Save Changes</Button>
        </div>
      </form>
    </div>
  );
};

export default EditLeadForm;
